import geetestVerify from './verifyGeetest'
import ajax from '@/plugins/ajax/request'
import { URLS } from '@Constant/index'
enum VerifyType {
  Img = 'img',
  Geetest = 'geetest'
}

export const verify = async (isRateLimited = false, biz_group = '') => {
  try {
    const res = await ajax.get(URLS.GET_GETES_INFO, {})
    const { gee_type, token, gt = '', challenge = '' } = res

    if (gee_type === VerifyType.Geetest) {
      return geetestVerify(
        {
          type: gee_type,
          token: token,
          geetest: {
            gt,
            challenge
          },
          biz_group
        },
        isRateLimited
      )
    }
  } catch (error) {
    return Promise.reject(error)
  }
}
